import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import TagsInput from './TagsInput';

/**
 * Compound input for the common backend pattern of [columnName, value1, value2, ...]
 * e.g. userTypeCol = ["USTYP", "A", "B"]
 *
 * Props:
 *   label        - group label shown above
 *   colLabel     - placeholder/label for the column name text field
 *   valuesLabel  - label shown above the tags input
 *   colValue     - current column name string
 *   values       - current array of filter values
 *   onColChange  - (string) => void
 *   onValuesChange - (array) => void
 *   valueType    - 'text' | 'number' passed to TagsInput
 *   helperText   - shown below tags input
 *   required     - marks column field as required
 */
export default function ColWithValuesInput({
  label,
  colLabel = 'Column Name',
  valuesLabel = 'Allowed Values',
  colValue,
  values,
  onColChange,
  onValuesChange,
  valueType = 'text',
  helperText,
  required = false
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {label && (
        <Typography variant="body2" fontWeight={500}>
          {label}
          {required && <span style={{ color: '#d32f2f' }}> *</span>}
        </Typography>
      )}

      <TextField
        size="small"
        label={colLabel}
        value={colValue}
        onChange={(e) => onColChange(e.target.value)}
        sx={{ maxWidth: 320 }}
      />

      <TagsInput
        label={valuesLabel}
        values={values}
        onChange={onValuesChange}
        type={valueType}
        helperText={helperText}
      />
    </Box>
  );
}
